import React, { useEffect } from 'react'
import { CategoryPicker, ProductCard } from 'components'
import { useSelector, shallowEqual, useDispatch } from 'dva'
import Swiper from './Swiper'
import Divider from './Divider'
import './index.less'

type Props = {}

const selector = ({ home, loading }) => ({
  spuList: home.spuList || [],
  loading: loading.effects['home/homepageQuery'],
})

const Home = (props: Props) => {
  const dispatch = useDispatch()
  const { spuList } = useSelector(selector, shallowEqual)

  useEffect(() => {
    dispatch({ type: 'home/homepageQuery' })
  }, [dispatch])

  return (
    <div className="home">
      <CategoryPicker isSticky />
      <div className="homeContent">
        <Swiper />
        {spuList.map(
          item =>
            !!item?.goodsInfoDTOS?.length && (
              <React.Fragment key={item.productCode}>
                <Divider
                  title={item.product}
                  productCode={item.productCode}
                  showMore={item.goodsInfoDTOS?.length > 4}
                />
                <div className="home-list">
                  {item.goodsInfoDTOS.map(
                    (goods, index) =>
                      index < 4 && (
                        <ProductCard
                          className="list-item"
                          key={goods.spuCode}
                          data={goods}
                        />
                      )
                  )}
                </div>
              </React.Fragment>
            )
        )}
      </div>
    </div>
  )
}

export default Home
